import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'
import type { Blocks, LegalText, SiteFrame } from '@/types/content'

import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import { LegalPageContent } from '@/components/sections/legal-page'
import { REVALIDATE_SECONDS, getLegalText, getPageContent } from '@/lib/content'

interface ImprintPageProps {
    frame: SiteFrame
    blocks: Blocks
    legal: LegalText | null
}

const ImprintPage: FC<ImprintPageProps> = ({ frame, blocks, legal }): ReactNode => {
    const seo = blocks['impressum.seo']

    return (
        <Layout frame={frame} showClosing={false}>
            <Seo
                title={seo?.ueberschrift ?? 'Impressum'}
                description={seo?.text ?? undefined}
                siteUrl={frame.settings.webseite}
                path='/impressum'
            />

            <LegalPageContent legal={legal} fallbackTitle='Impressum' />
        </Layout>
    )
}

export const getStaticProps: GetStaticProps<ImprintPageProps> = async () => {
    const [content, legal] = await Promise.all([
        getPageContent({ blocks: ['impressum.seo'] }),
        getLegalText('impressum')
    ])

    return {
        props: { frame: content.frame, blocks: content.blocks, legal },
        revalidate: REVALIDATE_SECONDS
    }
}

export default ImprintPage
